module.exports = __webpack_public_path__ + "static/media/preferredone.4d5dcc2c.svg";